<template>
  <div>
    <actor-detail-o-p-global
      :itemsBreadcrumbs="itemsBreadcrumbs"
      :sBackHref="sBackHref"
      :bWithPathOrNameRoute="true"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      itemsBreadcrumbs: [],
    };
  },
  beforeMount() {
    this.setNameBreadcrumbs();
  },
  methods: {
    setNameBreadcrumbs() {
      let aBreadcrumbs = [
        {
          text: "Operaciones pendientes",
          disabled: false,
          to: { name: "OPPending" },
        },
        {
          text: "Detalle de una operación pendiente",
          link: true,
          exact: true,
          disabled: false,
          to: { name: "OPPendingDetail" },
          params: { id: this.$route.params.idOP },
        },
        {
          text: "Detalle de una empresa",
          link: true,
          exact: true,
          disabled: true,
          to: { name: "" },
          params: { id: this.$route.params.id },
        },
      ];
      this.itemsBreadcrumbs = aBreadcrumbs;
      this.sBackHref = `/home/op-pending-detail/${this.$route.params.idOP}`;
    },
  },
};
</script>

<style>
</style>